import styled from '@emotion/styled';
import { Sticky } from '~/shared/components';
import { breakpoints } from '~/theme';

export const StyledContent = styled.div(({ theme }) => ({
    [breakpoints.sm]: {
        display: 'grid',
        gridTemplateColumns: `repeat(${theme.gridConfig.columnCount.md}, 1fr)`,
        gridAutoFlow: 'column',
        gap: theme.gridConfig.gap,
    },
}));

export const StyledProductImageColumn = styled.div({
    [breakpoints.sm]: {
        gridColumn: '1 / 8',
    },
    [breakpoints.md]: {
        gridColumn: '1 / 9',
    },
});

export const StyledProductInfoColumn = styled(Sticky)(({ theme }) => ({
    padding: `0 ${theme.gridConfig.gutter}`,
    [breakpoints.sm]: {
        padding: 0,
        gridColumn: '8 / 13',
    },
    [breakpoints.md]: {
        padding: 0,
        gridColumn: '9 / 13',
    },

    [breakpoints.xl]: {
        paddingRight: theme.spaces[8],
        paddingLeft: theme.spaces[4],
    },
}));
